import React from "react";
import { StaticImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';
import '../../sass/components/_components.footerPerform2025.scss';
import footerShapes from '../../images/footer_shapes_v2.svg';
import rightArrow from '../../images/arrow-right.svg';
import twitter from '../../images/icon-social-x.svg';
import linkedin from '../../images/icon-social-linkedin.svg';
import facebook from '../../images/icon-social-facebook.svg';
import instagram from '../../images/icon-social-instagram.svg';
import performLogo from '../../images/logo-footer-perform2025.svg';

const FooterPerform2025 = () => {
    return (
        <div className="cp-footerPerform2025">
            <div className="cp-footerPerform2025__inner">
                <div className="cp-footerPerform2025__inner-top">
                    <div className="cp-footerPerform2025__inner-top--inner l--flex">
                        <img src={footerShapes} alt="" />
                        <p>The most powerful conference for Finance, Accounting, Marketing, HR, and you!</p>
                        <a href="/perform/perform-registration/" className="l-button l-gtmTrigger">
                            <span>Register Now</span>
                            <img src={rightArrow} alt="" />
                        </a>
                    </div>
                </div>
                <div className="cp-footerPerform2025__inner-middle l--flex">
                    <a className="l-footer2023Perform" href="/">
                        <img loading="lazy" src={performLogo} alt="Planful" />
                    </a>
                    <nav>
                        <ul className="l--flex">
                            <li>
                                <a href="/perform/miami/">Miami</a>
                            </li>
                            <li>
                                <a href="/perform/london/">London</a>
                            </li>
                            <li>
                                <a href="/perform/faq/">FAQ's</a>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div className="cp-footerPerform2025__inner-bottom l--flex">
                    <div className="l--left l--flex">
                        <a className="l--genericBorderRadius l--flex" href="https://twitter.com/Planful" target="_blank" rel="noreferrer" aria-label="Twitter, opens in a new tab">
                            <img loading="lazy" src={twitter} alt="Twitter" />
                        </a>
                        <a className="l--genericBorderRadius l--flex" href="https://www.linkedin.com/company/planful-inc" target="_blank" rel="noreferrer" aria-label="LinkedIn, opens in a new tab">
                            <img loading="lazy" src={linkedin} alt="LinkedIn" />
                        </a>
                        <a className="l--genericBorderRadius l--flex" href="https://www.facebook.com/PlanfulInc/" target="_blank" rel="noreferrer" aria-label="Facebook, opens in a new tab">
                            <img loading="lazy" src={facebook} alt="Facebook" />
                        </a>
                        <a className="l--genericBorderRadius l--flex" href="https://www.instagram.com/planful_inc/" target="_blank" rel="noreferrer" aria-label="Instagram, opens in a new tab">
                            <img loading="lazy" src={instagram} alt="Instagram" />
                        </a>
                    </div>
                    <div className="l--right l--flex">
                        <a href="https://planful.com/" target="_blank">Visit Planful.com</a>
                        <a href="https://planful.com/privacy-policy/" target="_blank"> Privacy Policy</a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FooterPerform2025;